import { StandBase } from './standBase';

export class Label extends StandBase {
	fontSize: number = 16;
	color: string = '#000000';
	type: string = 'label';

	constructor(x: number, y: number, name: string = 'Text', angle?: number, fontSize?: number, color?: string, width?: number, depth?: number) {
		super(x, y, 0, 0, angle, name);

		if (fontSize != null) this.fontSize = fontSize;
		if (color != null) this.color = color;
		if (width != null) this.width = width;
		if (depth != null) this.depth = depth;
	}

	copy(): Label {
		return new Label(this.x, this.y, this.name, this.angle, this.fontSize, this.color, this.width, this.depth);
	}

	isEqual(label: Label): boolean {
		if (label.fontSize != this.fontSize) return false;
		if (label.color != this.color) return false;
		if (label.x != this.x) return false;
		if (label.y != this.y) return false;
		if (label.name != this.name) return false;
		if (label.angle != this.angle) return false;

		return true;
	}
}